import { createAsyncThunk } from '@reduxjs/toolkit'
import axios, { type AxiosError, type AxiosResponse } from 'axios'

import { dataInstance } from '../axiosInstance/instance'

export interface VehicleDataType {
  customerid: string
  vehicle_cat_id: number
  vehicle_subcatid: number
  modelid: string
  company_name: string
  contact_person: string
  contact_number: string
  purchase_date: string
  invoiceno: string
  image?: File | string
}
export interface BookingDataType {
  customerid: string
  slottype: string
  bookingdate: string
  technid: string
  vehicle_id: number
  locid: number | null;
  comments?: string; // add this line, '?' means optional
}


  

// get allmodels
export const getallmodels = createAsyncThunk('getallmodels', async (_, { rejectWithValue }) =>
  await dataInstance.get<AxiosResponse>('common/models')
    .then((response: AxiosResponse<AxiosResponse>) => response.data.data)
    .catch((error: AxiosError) => {
      if (axios.isAxiosError(error) && (error.response != null)) {
        const e: any = error.response.data
        return rejectWithValue(e.message)
      }
      return rejectWithValue('Unexpected error! try later')
    })
)

// add vehicle
// export const addVehicle = createAsyncThunk('addVehicle', async (vehicledata: VehicleDataType, { rejectWithValue }) =>
//   await dataInstance.post<AxiosResponse>('customer/add_vehicle', vehicledata)
//     .then((response: AxiosResponse<AxiosResponse>) => response.data.data)
//     .catch((error: AxiosError) => {
//       if (axios.isAxiosError(error) && (error.response != null)) {
//         const e: any = error.response.data
//         return rejectWithValue(e.message)
//       }
//       return rejectWithValue('Unexpected error! try later')
//     })
// )

export const addVehicle = createAsyncThunk(
  'addVehicle',
  async (vehicledata: VehicleDataType, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      // 1. SEND JSON AS STRING (backend requires this)
      formData.append(
        "data",
        JSON.stringify({
          company_name: vehicledata.company_name,
          contact_person: vehicledata.contact_person,
          contact_number: vehicledata.contact_number,
          purchase_date: vehicledata.purchase_date,
          invoiceno: vehicledata.invoiceno,
          vehicle_cat_id: vehicledata.vehicle_cat_id,
          vehicle_subcatid: vehicledata.vehicle_subcatid,
          modelid: vehicledata.modelid
        })
      );

      // 2. SEND FILE IF SELECTED
      if (vehicledata.image instanceof File) {
        formData.append("files", vehicledata.image);
      }

      // 3. Make POST request with FormData
      const response = await dataInstance.post(
        `customer/add_vehicle?customer_id=${vehicledata.customerid}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      return response.data;
    } catch (error: any) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue("Unexpected error! Try later");
    }
  }
);


export const getAllRentalVehicleList = createAsyncThunk(
  'getAllRentalVehicleList',
  async (payload: { start_date: string, end_date: string }, { rejectWithValue }) =>
    await dataInstance
      .post<AxiosResponse>('customer/get_available_rental_model_list', payload)
      .then((response: AxiosResponse<AxiosResponse>) => response.data.data)
      .catch((error: AxiosError) => {
        if (axios.isAxiosError(error) && error.response != null) {
          const e: any = error.response.data
          return rejectWithValue(e.message)
        }
        return rejectWithValue('Unexpected error! Try later')
      })
)

export const addToCartAPI = createAsyncThunk(
  'rentalVehicle/addToCart',
  async (
    {
      vehicleId,
      customerId,
      startDate,
      endDate
    }: { vehicleId: number, customerId: string, startDate: string, endDate: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await dataInstance.post('customer/customer_click_count', {
        vehicleId,
        customerId,
        startDate,
        endDate
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        const e: any = error.response.data
        return rejectWithValue(e.message)
      }
      return rejectWithValue('Unexpected error! Try later')
    }
  }
)
// getcustomer vehicle
export const getCustomerVehicle = createAsyncThunk('getCustomerVehicle', async (id: string, { rejectWithValue }) =>
  await dataInstance.get<AxiosResponse>(`customer/vehicles?customer_id=${id}`)
    .then((response: AxiosResponse<AxiosResponse>) => response.data.data)
    .catch((error: AxiosError) => {
      if (axios.isAxiosError(error) && (error.response != null)) {
        const e: any = error.response.data
        return rejectWithValue(e.message)
      }
      return rejectWithValue('Unexpected error! try later')
    })
)
// getcustomer vehicle
export const getAlltechnicians = createAsyncThunk('getAlltechnicians', async (_, { rejectWithValue }) =>
  await dataInstance.get<AxiosResponse>('customer/technicians')
    .then((response: AxiosResponse<AxiosResponse>) => response.data.data)
    .catch((error: AxiosError) => {
      if (axios.isAxiosError(error) && (error.response != null)) {
        const e: any = error.response.data
        return rejectWithValue(e.message)
      }
      return rejectWithValue('Unexpected error! try later')
    })
)
// get list of servicebooking
export const allservicebooking = createAsyncThunk('allservicebooking', async (id: string, { rejectWithValue }) =>
  await dataInstance.get<AxiosResponse>(`/customer/jobs?customer_id=${id}`)
    .then((response: AxiosResponse<AxiosResponse>) => response.data.data)
    .catch((error: AxiosError) => {
      if (axios.isAxiosError(error) && (error.response != null)) {
        const e: any = error.response.data
        return rejectWithValue(e.message)
      }
      return rejectWithValue('Unexpected error! try later')
    })
)
// get list of servicebooking
export const confirmbooking = createAsyncThunk('confirmbooking', async (id: string, { rejectWithValue }) =>
  await dataInstance.put<AxiosResponse>(`customer/confirm_job?booking_id=${id}`)
    .then((response: AxiosResponse<AxiosResponse>) => response.data.data)
    .catch((error: AxiosError) => {
      if (axios.isAxiosError(error) && (error.response != null)) {
        const e: any = error.response.data
        return rejectWithValue(e.message)
      }
      return rejectWithValue('Unexpected error! try later')
    })
)
// get list of servicebooking
export const rejectbooking = createAsyncThunk('rejctbooking', async (id: string, { rejectWithValue }) =>
  await dataInstance.put<AxiosResponse>(`/customer/close_job?booking_id=${id}`)
    .then((response: AxiosResponse<AxiosResponse>) => response.data.data)
    .catch((error: AxiosError) => {
      if (axios.isAxiosError(error) && (error.response != null)) {
        const e: any = error.response.data
        return rejectWithValue(e.message)
      }
      return rejectWithValue('Unexpected error! try later')
    })
)
// servicebooking
export const servicebooking = createAsyncThunk('servicebooking', async (bookingData: BookingDataType, { rejectWithValue }) =>
  await dataInstance.post<AxiosResponse>('customer/servicebooking', bookingData)
    .then((response: AxiosResponse<AxiosResponse>) => response.data.data)
    .catch((error: AxiosError) => {
      if (axios.isAxiosError(error) && (error.response != null)) {
        const e: any = error.response.data
        return rejectWithValue(e.message)
      }
      return rejectWithValue('Unexpected error! try later')
    })
)
// get customer saved addresses
export const getCustomerAddresses = createAsyncThunk(
  'getCustomerAddresses',
  async (customerid: string, { rejectWithValue }) =>
    await dataInstance
      .get(`customer/addresses?customer_id=${customerid}`)
      .then((response) => response.data)   // ✔ FIXED
      .catch((error: AxiosError) => {
        if (axios.isAxiosError(error) && error.response) {
          const errData = error.response.data as { message?: string };
          return rejectWithValue(errData.message || 'Something went wrong');
        }
        return rejectWithValue('Unexpected error! try later')
      })
)

// add new address
export const addNewAddress = createAsyncThunk(
  'addNewAddress',
  async (
    payload: { customerid: string; address: string; pincode: string },   // ✔ TYPE FIX ADDED
    { rejectWithValue }
  ) => {
    try {
      const response = await dataInstance.post(
        `customer/add_address?customer_id=${payload.customerid}`,
        {
          address: payload.address,
          pincode: payload.pincode
        }
      );
      return response.data;   // ✔ correct backend format
    } catch (error: any) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue("Unexpected error! try later");
    }
  }
);

